// src/services/api.js
import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API,
  
  
});

// Attached JWT token to every request if available

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  // public rooutes
  const publicRoutes =[
    "/support-assets/",
    "/support-assets/s/",
  ];

  const isPublic = publicRoutes.some(route => 
    config.url.startsWith(route)
  );

  if (token && !isPublic) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default API;
